<template>
<div>
<div class="container fluid" v-if="user.authenticated && !message">
<div class="row">
  <div class="col">
    <h4 class="achHeading">AUTHORIZATION AGREEMENT FOR AUTOMATIC WITHDRAWAL</h4>
    <p class="achParagraph">Lessee/Borrower hereby authorizes Lessor/Lender to initiate debit entries and to initiate, if necessary, credit entries and adjustments for any debit entries in error to the account indicated below (the “Account”) with the bank named below (the “Bank”) for all amounts due under the Contract, including without limitation, all Contract Payments, any purchase option, late fees, taxes, non-sufficient funds charges, reimbursements and other amounts due under the Contract. Lessee/Borrower further authorizes Lessor/Lender or any such designee to deliver a copy of this Addendum to the Bank as evidence of Lessee/Borrower’s authorization. <u>Lessee/Borrower reaffirms the account is a commercial account in the name of the Lessee/Borrower.</u>
    </p>
  </div>
</div>
<div class="row">
  <div class="col">
    <h4>Contract #: {{parentData}}</h4>
  </div>
</div>
<b-form enctype="multipart/form-data" @submit.prevent="validateBeforeSubmit" autocomplete="off">
<div class="row">
  <div class="col">
      <label class="label">Name on account</label>
      <p class="control has-icon has-icon-right">
        <b-input name="Account Name" v-model="achInfo.NameOnAccount" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Account Name') }" type="text"/>
        <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Account Name')" class="fa-1x"></font-awesome-icon>
        <span v-show="errors.has('Account Name')" class="help is-danger">{{ errors.first('Account Name') }}</span>
      </p>
  </div>
</div>
<div class="row">
  <div class="col">
    <label class="label">Bank Name</label>
    <p class="control has-icon has-icon-right">
      <b-input name="Bank Name" v-model="achInfo.BankName" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Bank Name') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Bank Name')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Bank Name')" class="help is-danger">{{ errors.first('Bank Name') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col">
    <label class="label">Phone</label>
    <p class="control has-icon has-icon-right">
      <masked-input name="Phone" v-model="achInfo.BankPhone" v-validate="'required'" mask="(111) 111-1111" :class="{'form-control input': true, 'is-danger': errors.has('Phone') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Phone')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Phone')" class="help is-danger">{{ errors.first('Phone') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col">
    <label class="label">Commercial Checking Account Number</label>
    <p class="control has-icon has-icon-right">
      <b-input name="Account Number" v-model="achInfo.CCAccountNumber" v-validate="'required|alpha_num'" :class="{'input': true, 'is-danger': errors.has('Account Number') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Account Number')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Account Number')" class="help is-danger">{{ errors.first('Account Number') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col">
    <label class="label">Transit / ABA Number (lower left corner of check, 9 digits):</label>
    <p class="control has-icon has-icon-right">
      <b-input name="ABA Number" v-model="achInfo.ABANumber" v-validate="'required|numeric|length:9'" :class="{'input': true, 'is-danger': errors.has('ABA Number') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('ABA Number')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('ABA Number')" class="help is-danger">{{ errors.first('ABA Number') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col">
    <p class="achParagraph">This authority is to remain in full force and effect until Lessor/Lender and the Bank have received written notification from Lessee/Borrower of its termination in such time and in such manner as to afford Lessor/Lender and the Bank a reasonable opportunity to act on it, it expressly being understood that a minimum of 15 business days is required. Lessee/Borrower represents, warrants, covenants and agrees that, until all of its obligations under the Contract are satisfied in full: (a) its authorizations to Lessor/Lender and its designee hereunder may be revoked only with the Lessor’s/Lender’s prior written consent and any withdrawal of this authority or closing of the Account without the express written consent of Lessor/Lender shall constitute a default of the Contract; (b) the account identified by account name, account number and bank name and address that is shown on the face of the voided check that Lessee/Borrower provides to Lessor/Lender by attaching to this Addendum is the Account set forth above; (c) Lessee/Borrower will maintain the Account in good standing with the Bank throughout the term of the Contract, except as provided herein; and (d) Lessor/Lender or its designee may, at any time and from time to time, issue a pre-notification to the Bank with respect to such Account.</p>
    <h4 class="achHeading">AUTHORIZATION</h4>
    <p class="achParagraph">By typing your name below, you are signing this Agreement electronically. You agree your electronic signature is the legal equivalent to your manual/handwritten signature on this Agreement. By electronically signing using any device, means or action, you consent to the legally binding terms and conditions of this Agreement. You further agree that your signature on this document (hereafter referred to as your "E-Signature") is as valid as if you signed the document in writing. You also agree that no certification authority or other third party verification is necessary to validate your E-Signature, and that the lack of such certification or third party verification will not in any way affect the enforceability of your E-Signature or any resulting agreement between you and Pawnee Leasing Corporation. You are also confirming that you are the authorized representative of the Lessee/Borrower to enter into this Agreement. You further agree that your E- Signature constitutes your agreement to be bound by the terms and conditions of these Disclosures and Agreement as they exist on the date of your E- Signature on this form. Pawnee Leasing Corporation will not make changes to the existing ACH information if the new information you provide is invalid or incomplete. The information will be discarded and a new request may need to be made with the necessary information to in order to update the company’s records.</p>
  </div>
</div>
<div class="row">
  <div class="col">
    <label class="label">LESSEE/BORROWER</label>
    <p class="control has-icon has-icon-right">
      <b-input name="Lessee Name" v-model="achInfo.LesseeName" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Lessee Name') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Lessee Name')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Lessee Name')" class="help is-danger">{{ errors.first('Lessee Name') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col">
    <label class="label">Authorized Signer</label>
    <p class="control has-icon has-icon-right">
      <b-input name="Authorized Signer" v-model="achInfo.AuthorizedSigner" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Authorized Signer') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Authorized Signer')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Authorized Signer')" class="help is-danger">{{ errors.first('Authorized Signer') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col">
    <label class="label">Print Name</label>
    <p class="control has-icon has-icon-right">
      <b-input name="Print Name" v-model="achInfo.PrintName" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Print Name') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Print Name')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Print Name')" class="help is-danger">{{ errors.first('Print Name') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col">
    <label class="label">Title</label>
    <p class="control has-icon has-icon-right">
      <b-input name="Title" v-model="achInfo.Title" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Title') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Title')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Title')" class="help is-danger">{{ errors.first('Title') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col">
    <label class="label">Date</label>
    <p class="control has-icon has-icon-right">
      <b-input name="Date" v-model="achInfo.Date" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Date') }" type="date" />
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Date')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Date')" class="help is-danger">{{ errors.first('Date') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col">
    <label class="label">Attach Copy of Voided Check</label>
    <p class="fileUploadText">****TEMPORARY CHECKS WILL NOT BE ACCEPTED WITHOUT A LETTER FROM THE BANK ****</p>
    <p class="fileUploadText">File types allowed are JPG, PDF and PNG up to 5mb in size.</p>
    <p class="control has-icon has-icon-right">
      <input name="checkupload" id="files" ref="files" multiple v-on:change="handleFilesUpload()" v-validate="'required|ext:jpeg,jpg,png,pdf'" :class="{'input': true, 'is-danger': errors.has('checkupload') }" type="file" placeholder="Attach Image"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('checkupload')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('checkupload')" class="help is-danger">{{ errors.first('checkupload') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col">
    <p class="control">
      <button class="btn btn-primary" type="submit">Submit</button>
    </p>
  </div>
</div>
</b-form>
</div>
<div class="container fluid" v-else-if="user.authenticated && message">
    <div class='row'>
      <div class='col' >
        <h4 :class='sentClass'>{{message}}</h4>
      </div>
    </div>
  </div>
<div class="row" v-else>
  <div class="col text-center">
  <h3>Sorry it looks like you've been logged out, please <router-link to="/login">Login</router-link> to resume</h3>
  </div>
</div>
</div>
</template>

<script>
import auth from './auth'
import axios from 'axios'
import moment from 'moment'
import MaskedInput from 'vue-masked-input'
export default {
  name: 'modalACH',
  components: {
    MaskedInput
  },
  props: {
    parentData: {
      type: Number
    },
    modalachid: {
      type: String
    }
  },
  data: function () {
    return {
      checkupload: '',
      achInfo: {
        Date: ''
      },
      files: '',
      message: '',
      sentClass: '',
      timer: '',
      user: auth.user,
      apiUrl: localStorage.getItem('apiURL')
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.achInfo.ConfirmedAuthorization = true
          if (this.achInfo.Date) {
            this.achInfo.Date = moment(this.achInfo.Date).format('YYYY-MM-DD')
          }
          let formData = new FormData()
          /*
          Iterate over any file sent over appending the files
          to the form data.
          */
          Object.keys(this.achInfo).forEach((key) => {
            formData.append(key, this.achInfo[key])
          })
          for (var i = 0; i < this.files.length; i++) {
            let file = this.files[i]
            formData.append('files', file)
          }
          formData.append('json', JSON.stringify(this.achInfo))
          this.achInfo.Date = moment(this.achInfo.Date).format('MM-DD-YYYY')
          // Data is valid, so we can submit the form.
          let uri = this.apiUrl + auth.user.clientID + '/contracts/' + this.parentData + '/billingaccounts/ACHAuth'
          axios.post(uri, formData, {headers: auth.getAuthHeader()}).then((response) => {
            this.sentClass = 'text-success'
            this.message = 'Thank you for submitting your ACH information. We will process it as quickly as possible.'
            this.achInfo = {}
            this.timer = setTimeout(() => {
              this.$root.$emit('bv::hide::modal', this.modalachid)
              this.message = ''
            }, 10000)
          }).catch(() => {
            this.sentClass = 'text-danger'
            this.message = 'Something went wrong please try again later.'
            this.timer = setTimeout(() => { this.message = '' }, 10000)
          })
        }
      })
    },
    handleFilesUpload () {
      this.files = this.$refs.files.files
      console.log(this.files)
    },
    resetACHForm () {
      this.achInfo = {}
      this.$validator.validateAll().then((result) => {
        this.$validator.pause()
        this.$nextTick(() => {
          this.$validator.errors.clear()
          this.$validator.fields.items.forEach(field => field.reset())
          this.$validator.fields.items.forEach(field => this.errors.remove(field))
          this.$validator.resume()
        })
      })
    }
  },
  mounted: function () {
    this.$root.$on('bv::modal::hide', (bvEvent, modalachid) => {
      this.resetACHForm()
    })
  }
}
</script>

<style>
.achParagraph {font-size: 0.8em;}
.achHeading {background: #000000; color:#ffffff; padding:5px;}
.is-danger {color:red;}
.input {width:50%;}
.fileUploadText {font-size:0.8em; margin:0; padding: 0;}
</style>



// WEBPACK FOOTER //
// src/modalACH.vue